import React from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import BaseLinearContent from '@/components/Common/BaseLinearContent';
import classNames from 'classnames';
import Image from 'next/image';

const ChooseContent = () => {
  const { t } = useTranslation();

  const dataList = [
    {
      icon: '/images/api/api-hair-salons-stylists.webp',
      title: t('Hair Salons & Stylists'),
      desc: t(
        'Empower clients with virtual consultations, easy appointment booking, and a digital portfolio to showcase your work.'
      )
    },
    {
      icon: '/images/api/api-har-care-brands.webp',
      title: t('Hair Care Brands'),
      desc: t(
        'Provide personalized product recommendations and let users experiment with different hair colors before they commit.'
      )
    },
    {
      icon: '/images/api/api-wig-merchants.webp',
      title: t('Wig Merchants'),
      desc: t('Let customers virtually try on wigs before purchasing to find their perfect look.')
    },
    {
      icon: '/images/api/api-influencers.webp',
      title: t('Influencers'),
      desc: t(
        'Create virtual try-ons and styling tutorials, making it easier to showcase products and styles to followers.'
      )
    },
    {
      icon: '/images/api/api-events-photoshoots.webp',
      title: t('Events & Photoshoots'),
      desc: t(
        'Allow models and event stylists to experiment with different hairstyles before photoshoots or big events.'
      )
    },
    {
      icon: '/images/api/api-fashion-retailers.webp',
      title: t('Fashion Retailers'),
      desc: t('Show complete style solutions by combining hairstyles and outfits for a seamless shopping experience.')
    }
  ];

  return (
    <div className={styles.content}>
      <h2>
        <span>{t('For All Your Hairstyling Needs - Hairpaca API')}</span>
      </h2>

      <BaseLinearContent>
        <div className={styles.container}>
          {dataList.map((item, index) => {
            return (
              <div className={styles.cardContainer} key={index + item.title}>
                <Image src={item?.icon ?? ''} alt={'icon'} className={styles.icon} width={50} height={50} />

                <p className={classNames(styles.title)}>{item.title}</p>
                <p className={styles.desc} dangerouslySetInnerHTML={{ __html: item.desc }} />
              </div>
            );
          })}
        </div>
      </BaseLinearContent>
    </div>
  );
};

export default ChooseContent;
